<!-- Compiled at 2026-10-07T06:21:14.844Z -->
<ng-container *ngIf="$isVariablesInitialized()">
	<ng-container *lowgileScope="null; screen: this; let $scope">
		<ng-container *lowgileForm="null; screen: this; let $formDirective">
			<div style="display: contents" [class.fill]="false">
				<div
					class="layout-block"
					[style.align-items]="'inherit'"
					[class.grid-horizontal]="Sys.Layout.sizeIsGreaterThanOrEqual.XSmall"
					[class.vertical]="Sys.Layout.sizeIsLessThan.XSmall"
					[style.--layout-column-count]="screen.columnVisibility.columnCount"
					[style.gap]="'0.5em 1em'"
				>
					<span
						[style.grid-column]="'span ' + (1)"
						[innerHtml]="'Goal description*' | escapeHtml: 'none' | replaceNewlines: 'span'"
					></span>
					<ng-container *ngIf="screen.columnVisibility.showRejectionComments"
						><span
							[style.grid-column]="'span ' + (1)"
							[innerHtml]="'Rejection comment' | escapeHtml: 'none' | replaceNewlines: 'span'"
						></span
					></ng-container>

					<ng-container *ngIf="screen.columnVisibility.showSelfReview"
						><span
							[style.grid-column]="'span ' + (1)"
							[innerHtml]="'Self review*' | escapeHtml: 'none' | replaceNewlines: 'span'"
						></span
					></ng-container>

					<ng-container *ngIf="screen.columnVisibility.showManagerReview"
						><span
							[style.grid-column]="'span ' + (1)"
							[innerHtml]="'Manager evaluation*' | escapeHtml: 'none' | replaceNewlines: 'span'"
						></span
					></ng-container>

					<div
						class="layout-block vertical"
						[style.grid-column]="'span ' + (1)"
						[style.align-items]="'inherit'"
						[style.gap]="'1em'"
					>
						<ng-container
							*ngrxLet="(!devBarService.isEnableEverything()) && ($disabled || !!((screen.viewMode.isManager && (!screen.columnVisibility.isFutureGoals || !screen.gs.status.isSelfReviewDone)) || (screen.viewMode.isEmployee && !screen.gs.status.employeeCanEdit))) as $disabled"
						>
							<ng-container *ngIf="$disabled; else else26"
								><span
									style="border: 1px solid lightgray; padding: 0 0.5em"
									[innerHtml]="screen.goal.goalDescription || '<p>&nbsp;</p>' | escapeHtml: 'safe' | replaceNewlines: 'span'"
								></span
							></ng-container>
							<ng-template #else26>
								@let $fc_12_1 = getFormControl(screen.goal, 'goalDescription', 12,
								$scope, $formDirective, $disabled, $ignoreValidations);
								<div>
									<lowgile-rich-text-editor
										[formControl]="$fc_12_1"
										[placeholder]="'Enter your goal description'"
									/>
									<div style="color: var(--mat-form-field-error-text-color)">
										@if($fc_12_1.dirty || $fc_12_1.touched) { @for(error of
										$fc_12_1.errors ?? {} | keyvalue; track error.key) {
										<mat-error
											*ngIf="typeof error.value == 'string'"
											[innerHtml]="error.value | escapeHtml: 'safe'"
										/>
										} }
									</div>
								</div>
							</ng-template>
						</ng-container>
					</div>
					<ng-container *ngIf="screen.columnVisibility.showRejectionComments"
						><div
							class="layout-block vertical"
							[style.grid-column]="'span ' + (1)"
							[style.align-items]="'inherit'"
							[style.gap]="'1em'"
						>
							<ng-container
								*ngrxLet="(!devBarService.isEnableEverything()) && ($disabled || !!(screen.viewMode.isEmployee)) as $disabled"
							>
								<ng-container *ngIf="$disabled; else else49"
									><span
										style="border: 1px solid lightgray; padding: 0 0.5em"
										[innerHtml]="screen.goal.rejectionComment || '<p>&nbsp;</p>' | escapeHtml: 'safe' | replaceNewlines: 'span'"
									></span
								></ng-container>
								<ng-template #else49>
									@let $fc_6_1 = getFormControl(screen.goal, 'rejectionComment',
									6, $scope, $formDirective, $disabled, $ignoreValidations);
									<div>
										<lowgile-rich-text-editor
											[formControl]="$fc_6_1"
											[placeholder]="'Comment in case of rejection'"
										/>
										<div
											style="color: var(--mat-form-field-error-text-color)"
										></div>
									</div>
								</ng-template>
							</ng-container></div
					></ng-container>

					<ng-container *ngIf="screen.columnVisibility.showSelfReview"
						><div
							class="layout-block vertical"
							[style.grid-column]="'span ' + (1)"
							[style.align-items]="'inherit'"
							[style.gap]="'1em'"
						>
							<ng-container
								*ngrxLet="(!devBarService.isEnableEverything()) && ($disabled || !!(screen.viewMode.isManager || (screen.viewMode.isEmployee && !screen.gs.status.isSelfReviewPending))) as $disabled"
							>
								<ng-container *ngIf="$disabled; else else45"
									><span
										style="border: 1px solid lightgray; padding: 0 0.5em"
										[innerHtml]="screen.goal.selfRating || '<p>&nbsp;</p>' | escapeHtml: 'safe' | replaceNewlines: 'span'"
									></span
								></ng-container>
								<ng-template #else45>
									@let $fc_7_1 = getFormControl(screen.goal, 'selfRating', 7,
									$scope, $formDirective, $disabled, $ignoreValidations);
									<div>
										<lowgile-rich-text-editor
											[formControl]="$fc_7_1"
											[placeholder]="'Employee: Enter how you feel you achieved this goal'"
										/>
										<div style="color: var(--mat-form-field-error-text-color)">
											@if($fc_7_1.dirty || $fc_7_1.touched) { @for(error of
											$fc_7_1.errors ?? {} | keyvalue; track error.key) {
											<mat-error
												*ngIf="typeof error.value == 'string'"
												[innerHtml]="error.value | escapeHtml: 'safe'"
											/>
											} }
										</div>
									</div>
								</ng-template>
							</ng-container>
						</div></ng-container
					>

					<ng-container *ngIf="screen.columnVisibility.showManagerReview"
						><div
							class="layout-block vertical"
							[style.grid-column]="'span ' + (1)"
							[style.align-items]="'inherit'"
							[style.gap]="'1em'"
						>
							<ng-container
								*ngrxLet="(!devBarService.isEnableEverything()) && ($disabled || !!(screen.viewMode.isEmployee || (screen.viewMode.isManager && !screen.gs.status.isSelfReviewDone))) as $disabled"
							>
								<ng-container *ngIf="$disabled; else else41"
									><span
										style="border: 1px solid lightgray; padding: 0 0.5em"
										[innerHtml]="screen.goal.managerRating || '<p>&nbsp;</p>' | escapeHtml: 'safe' | replaceNewlines: 'span'"
									></span
								></ng-container>
								<ng-template #else41>
									@let $fc_34_1 = getFormControl(screen.goal, 'managerRating', 34,
									$scope, $formDirective, $disabled, $ignoreValidations);
									<div>
										<lowgile-rich-text-editor
											[formControl]="$fc_34_1"
											[placeholder]="'Employee: Enter how you feel you achieved this goal'"
										/>
										<div style="color: var(--mat-form-field-error-text-color)">
											@if($fc_34_1.dirty || $fc_34_1.touched) { @for(error of
											$fc_34_1.errors ?? {} | keyvalue; track error.key) {
											<mat-error
												*ngIf="typeof error.value == 'string'"
												[innerHtml]="error.value | escapeHtml: 'safe'"
											/>
											} }
										</div>
									</div>
								</ng-template>
							</ng-container>
						</div></ng-container
					>
				</div>
			</div>
		</ng-container>
	</ng-container>
</ng-container>
